var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageOnLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_52233",
    "data-name": "Group 52233",
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 62,
    viewBox: "0 0 108 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_52832",
    "data-name": "Path 52832",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 107.75 61.75 L 0.25 61.75 L 0.25 0.25 L 107.75 0.25 L 107.75 61.75 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 0.5 L 0.5 61.5 L 107.5 61.5 L 107.5 0.5 L 0.5 0.5 M 0 0 L 108 0 L 108 62 L 0 62 L 0 0 Z",
    stroke: "none",
    fill: "#b2b2bf"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_52229",
    "data-name": "Group 52229",
    transform: "translate(8.389 8.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9372",
    "data-name": "Rectangle 9372",
    transform: "translate(-0.389 -0.389)",
    fill: "#fff",
    stroke: "#b2b2bf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 47,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 90.5,
    height: 46.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9373",
    "data-name": "Rectangle 9373",
    transform: "translate(-0.389 -0.389)",
    fill: "#d1d6dd",
    stroke: "#d1d6dd",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 47,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 47.5,
    height: 46.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-image",
    "data-name": "Icon metro-image",
    d: "M35.489,6.051l0,0v26.33l0,0H4.769l0,0V6.055l0,0Zm0-2.195H4.766A2.2,2.2,0,0,0,2.571,6.051V32.389a2.2,2.2,0,0,0,2.195,2.195H35.493a2.2,2.2,0,0,0,2.195-2.195V6.051a2.2,2.2,0,0,0-2.195-2.195ZM31.1,11.538a3.292,3.292,0,1,1-3.292-3.292A3.292,3.292,0,0,1,31.1,11.538ZM33.3,30.194H6.96V25.8l7.682-13.169,8.779,10.974h2.195L33.3,17.025Z",
    transform: "translate(3.041 3.755)",
    fill: "#f1f1f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Copy_211",
    "data-name": "Rectangle Copy 211",
    transform: "translate(54.23 8.923)",
    fill: "#f1f1f5",
    stroke: "#b2b2bf",
    strokeWidth: 1,
    strokeDasharray: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.581,
    height: 27.712,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26.581,
    height: 26.712,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOnLeft);
export default __webpack_public_path__ + "static/media/imageOnLeft.8aeee57ffba33961ea9091b8c317a525.svg";
export { ForwardRef as ReactComponent };